import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { SvgGeometryRemove, SecondaryBtn } from '@tmapy/style-guide';
import { actionActivateDeleteTool, actionDeactivateTools } from '../actions';
export const DeleteToolBtn = ({ isActive, dispatch, children }) => {
    const handleClick = useCallback(() => {
        if (isActive) {
            dispatch(actionDeactivateTools());
        }
        else {
            dispatch(actionActivateDeleteTool());
        }
    }, [dispatch, isActive]);
    return (_jsx(SecondaryBtn, { icon: { element: _jsx(SvgGeometryRemove, {}) }, isDanger: true, isActive: isActive, tooltip: children, onClick: handleClick }));
};
//# sourceMappingURL=DeleteToolBtn.js.map